export default __webpack_public_path__ + "static/media/placas.c83163dd.png";